import { z } from 'zod';
import { numericSchema } from './shared/numeric-schema';

// ─── Entity Schema ────────────────────────────────────────────────────────────

/**
 * Schema for the exchange rate object.
 * Transforms the rate (string or number) into a guaranteed number.
 */
export const exchangeRateSchema = z.object({
  rate: numericSchema.transform(v => v ?? 0),
});

export type ExchangeRate = z.infer<typeof exchangeRateSchema>;

// ─── API Response Schemas ─────────────────────────────────────────────────────

/**
 * The mock server returns the rate directly in the root of the object.
 * Format: { rate: "1.000000" }
 */
export const exchangeRateResponseSchema = exchangeRateSchema;

export type ExchangeRateResponse = z.infer<typeof exchangeRateResponseSchema>;
